import {
  MdPersonAdd,
  MdEventAvailable,
  MdCardMembership,
  MdAcUnit,
  MdConfirmationNumber,
  MdEvent,
  MdBuild,
  MdFitnessCenter,
  MdPerson,
  MdSubscriptions,
  MdPayments,
  MdAccountBalance,
  MdAssessment,
  MdSummarize,
  MdDescription,
  MdDashboard,
  MdPointOfSale,
  MdPeople,
} from 'react-icons/md';
import { RECEPTIONIST_SALE_PAGES } from '../pages/receptionist/sales/salePageConfig';

const saleItems = RECEPTIONIST_SALE_PAGES.map(({ path, label, icon }) => ({ path, label, icon }));

export const receptionistNavItems = [
  { path: '/receptionist/dashboard', label: 'Dashboard', icon: MdDashboard, end: true },
  {
    id: 'members',
    label: 'Members',
    icon: MdPeople,
    children: [
      { path: '/receptionist/members', label: 'Members', icon: MdPersonAdd },
      { path: '/receptionist/subscriptions', label: 'Subscriptions', icon: MdSubscriptions },
      { path: '/receptionist/memberships', label: 'Memberships', icon: MdCardMembership },
      { path: '/receptionist/freeze', label: 'Freeze', icon: MdAcUnit },
    ],
  },
  {
    id: 'sales',
    label: 'Sales',
    icon: MdPointOfSale,
    children: [
      { path: '/receptionist/guest-pass', label: 'Guest Pass', icon: MdConfirmationNumber },
      ...saleItems,
      { path: '/receptionist/remaining-payments', label: 'Remaining Payments', icon: MdPayments },
      { path: '/receptionist/remaining-payments-report', label: 'Remaining Payments Report', icon: MdAssessment },
    ],
  },
  {
    id: 'operations',
    label: 'Operations',
    icon: MdEventAvailable,
    children: [
      { path: '/receptionist/attendance', label: 'Attendance', icon: MdEventAvailable },
      { path: '/receptionist/classes', label: 'Classes', icon: MdEvent },
      { path: '/receptionist/equipments', label: 'Equipments', icon: MdBuild },
      { path: '/receptionist/trainer', label: 'Trainer', icon: MdFitnessCenter },
    ],
  },
  {
    id: 'reports',
    label: 'Reports',
    icon: MdSummarize,
    children: [
      { path: '/receptionist/detailed-report', label: 'Detailed Report', icon: MdDescription },
      { path: '/receptionist/petty-cash', label: 'Petty Cash', icon: MdPayments },
      { path: '/receptionist/bank', label: 'Bank', icon: MdAccountBalance },
      { path: '/receptionist/z-report', label: 'Z Report', icon: MdSummarize },
      { path: '/receptionist/z-report-1', label: 'Z Report 1', icon: MdSummarize },
    ],
  },
  { path: '/receptionist/profile', label: 'Profile', icon: MdPerson },
];
